import { Spinner as Spinz } from "spin.js";
import Pager from "./pagination.mjs";
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { sortEmployment, sortEarnings } from "./sorters.mjs";
import {htmlLegendPlugin, getLegendList} from "./pie-legend.mjs";
import pattern from "patternomaly";
import tabler from "./tabler.mjs";
import format from "./tabler.mjs";
import 'core-js/actual/promise';
import 'whatwg-fetch';

(function () {
  if (document.getElementById("career-list")) {
    /**
     * Store relevant data for all charts for easy reinstantiation
     */
    const chartData = {
      rows: [],
    };

    const controls = document.getElementById("controls");
    /** Wrapper for career list */
    const wrapper = document.getElementById("career-list");
    /** ul list element to hold career data containers */
    const el = document.createElement('ul')
    el.id = "careerData"
    el.setAttribute('aria-label', "Career Data for Careers related to program");
    el.classList.add("accordion", "list", "career-data")

    const mask = document.createElement("div");
    mask.classList.add("loading");
    wrapper.prepend(mask);

    // const el = document.getElementById("careerData");
    /** options for spinner plugin */
    const opts = {
      lines: 13, // The number of lines to draw
      length: 38, // The length of each line
      width: 17, // The line thickness
      radius: 45, // The radius of the inner circle
      scale: 0.5, // Scales overall size of the spinner
      corners: 1, // Corner roundness (0..1)
      speed: 1, // Rounds per second
      rotate: 0, // The rotation offset
      animation: "spinner-line-fade-quick", // The CSS animation name for the lines
      direction: 1, // 1: clockwise, -1: counterclockwise
      color: "#003366", // CSS color or array of colors
      fadeColor: "transparent", // CSS color or array of colors
      top: "35%", // Top position relative to parent
      left: "50%", // Left position relative to parent
      shadow: "0 0 1px transparent", // Box-shadow for the lines
      zIndex: 2000000000, // The z-index (defaults to 2e9)
      className: "spinner", // The CSS class to assign to the spinner
      position: "absolute", // Element positioning
    };

    const spinner = new Spinz(opts).spin(wrapper);
    /**
     * utility function for reformating array into expected values
     *
     * @param {array} myArray
     * @param {string} columnName
     * @returns
     */
    function arrayColumns(myArray, columnName) {
      //console.log(myArray);
      return myArray.map(function (value, index) {
        return value[columnName];
      });
    }

    function handleCharts(e) {
      setTimeout(function () {
        var target = e.target;
        var id = target.getAttribute("data-id");

        if (!target.classList.contains("chart-live")) {
          chartData.rows[id].charts.forEach(function (e) {
            //console.log(e);
            //console.log(setOptions(e.data, i));
            e.chart = new Chart(
              e.canvas,
              formatOptions[e.canvas.getAttribute("data-chart")](e.data, id)
            );
          });
          target.classList.toggle("chart-live");
        } else {
          chartData.rows[id].charts.forEach(function (e, i) {
            e.chart.destroy();
          });
          target.classList.toggle("chart-live");
        }
      }, 1);
    }

    /**
     * Object with functions to create output option objects for chart.js
     * @namespace
     */
    const formatOptions = {
      /**
       * Earnings bar chart options
       *
       * @memberof formatOptions
       * @param {object} data formatted data object populated from API call
       * @returns {object} options object
       */
      earnings: function (data, id) {
        let options = {
          type: "bar",
          data: {
            labels: data.x,
            datasets: [
              {
                label: "Annual Earnings",
                data: data.y,
                borderWidth: 1,
              },
            ],
          },
          options: {
            color: "#333",
            backgroundColor: "rgba(0, 34, 101, 0.7)",
            borderColor: "#002265",
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: "Earnings (USD)",
                  color: "#002265",
                },
                ticks: {
                  callback: function (value, index, values) {
                    return "$" + value;
                  },
                  color: "#333",
                },
              },
              x: {
                title: {
                  display: true,
                  text: "Percentile",
                  color: "#002265",
                },
                ticks: {
                  callback: function (value, index, values) {
                    function processNum(i) {
                      var j = i % 10,
                        k = i % 100;
                      if (j == 1 && k != 11) {
                        return i + "st";
                      }
                      if (j == 2 && k != 12) {
                        return i + "nd";
                      }
                      if (j == 3 && k != 13) {
                        return i + "rd";
                      }
                      return parseInt(i) + "th";
                    }
                    return processNum(this.getLabelForValue(value));
                  },
                },
              },
            },
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    var label = "";

                    if (context.parsed.y !== null) {
                      label += new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(context.parsed.y);
                    }
                    return label;
                  },
                  title: function (context) {
                    function processNum(i) {
                      var j = i % 10,
                        k = i % 100;
                      if (j == 1 && k != 11) {
                        return i + "st";
                      }
                      if (j == 2 && k != 12) {
                        return i + "nd";
                      }
                      if (j == 3 && k != 13) {
                        return i + "rd";
                      }
                      return parseInt(i) + "th";
                    }

                    return (
                      processNum(parseInt(context[0].label)) + " Percentile"
                    );
                  },
                },
              },
            },
          },
        };
        return options;
      },
      /**
       * Employment Projection Line Plot Options
       *
       * @memberof formatOptions
       * @param {object} data formatted data object populated from API call
       * @returns {object} options object
       */
      employment: function (data, id) {
        let options = {
          type: "line",
          data: {
            labels: data.x,
            datasets: [
              {
                label: "Employment (10 Year Projection)",
                data: data.y,
              },
            ],
          },
          options: {
            color: "#333",
            plugins: {
              legend: {
                display: false,
              },
            },
            borderColor: "#002265",
            scales: {
              y: {
                title: {
                  display: true,
                  text: "Employment",
                  color: "#002265",
                },
                ticks: {
                  stepSize: 1.0,
                },
              },
              x: {
                title: {
                  display: true,
                  text: "Year",
                  color: "#002265",
                },
              },
            },
          },
          responsive: true,
        };
        return options;
      },
      /**
       * Education Pie Graph Options
       *
       * @memberof formatOptions
       * @param {object} data formatted data object populated from API call
       * @returns {object} options object
       */
      education: function (data, id) {
        let options = {
          type: "pie",
          data: {
            labels: [
              "High School or less",
              "Certificate",
              "Some College",
              "Associate Degree",
              "Bachelor's Degree",
              "Master's Degree",
              "Doctoral Degree +",
            ],
            datasets: [
              {
                label: "Education level in career",
                data: data.y,
                backgroundColor: [
                  pattern.draw("square", "#4dc9f6"),
                  pattern.draw("line-vertical","#f67019"),
                  pattern.draw("ring","#f53794"),
                  pattern.draw("dash", "#537bc4"),
                  pattern.draw("zigzag","#acc236"),
                  pattern.draw("diamond","#166a8f"),
                  pattern.draw("dot","#00a950")
                ],
              },
            ],
          },
          options: {
            color: "#333",
            responsive: true,
            aspectRatio:  1.44,
            plugins: {
              datalabels: {
                anchor: "center",
                align: "end",
                offset: 5,
                display: function(context) {
                  //console.log(context)
                  var value = context.dataset.data[context.dataIndex];
                  return parseFloat(value) > 10 ? true : false;
                },
                formatter: function(value, context) {
                  return value.toFixed(2) + "%";
                },
                backgroundColor: "rgba(51,51,51,0.7)",
                padding: 3,
                borderRadius: 5,
                color: "#fff",
                font: {
                  size: '11px'
                }
              },
              htmlLegend: {
                containerID: "legend-" + id,
              },
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    var label = context.label || "";
                    if (label) {
                      label += ": ";
                    }
                    if (context.parsed.y !== null) {
                      label += context.formattedValue + "%";
                    }
                    return label;
                  },
                },
              },
            },
          },
          plugins: [htmlLegendPlugin, ChartDataLabels],
        };
        return options;
      },
    };

    /**
     * prints API data to template
     *
     * @param {json} json api results
     *
     */
    function fillTemplate(json) {
      json.forEach(function (e, i) {
        var template = "";
        var item = "";
        if (document.getElementById("career-template")) {
          var template = document.getElementById("career-template");
        } else {
          throw new Error("No template found");
        }
        //set body fields
        const mappings = {
          name: e["humanized-title"],
          description: e.description,
          education: e["typical-ed-level"],
          openings: e["annual-openings"],
          employment: e["employment-current"],
          earnings:
            "$" +
            Math.round(parseInt(e["median-earnings"])).toLocaleString("en-US"),
        };

        item = document.importNode(template.content, true);
        const anchor = item.querySelector(".career-data__heading");
        const slots = item.querySelectorAll(".slot");
        //console.log(slots);

//<span aria-hidden="true" class="accordion__icon fas fa-chevron-circle-right"></span>

        //Set parameters necessary for accordion
        anchor.dataset.id = i;
        //anchor.dataset.controls = "tab-" + i;
        anchor.id = "tab-" + i + "-heading";
        anchor.dataset.target = "#" + "tab-" + i;
        anchor.innerHTML = `<span aria-hidden="true" class="accordion__icon fas fa-chevron-circle-right"></span>${e["humanized-title"]}`
        anchor.setAttribute("aria-controls", "tab-" + i);
        anchor.setAttribute("aria-expanded", "false");

        //set body parameters
        slots.forEach(function (slot) {
          if (slot.dataset.slot && mappings[slot.dataset.slot] != null) {
            //console.log(String(mappings[slot.dataset.slot]));
            slot.innerText = String(mappings[slot.dataset.slot]);
          }
        });
        //accordion body parameters
        const body = item.querySelector(".accordion-body");
        body.id = "tab-" + i;
        body.setAttribute("aria-labelledby", "tab-" + i + "-heading");

        //set canvas IDs
        let canvi = item.querySelectorAll(".chart");

        canvi[0].id = "annual-earnings-" + i;
        canvi[0].appendChild(tabler(["percentile","earnings"], e["annual-earnings"], false, "Accessible - Annual Earnings by Percentile"));
        canvi[0].parentNode.append(tabler(["percentile","earnings"], e["annual-earnings"], true, "Accessible - Annual Earnings by Percentile"));

        canvi[1].id = "employment-" + i;
        canvi[1].appendChild(tabler(["year","number"], e["employment"], false, "Accessible - Employment 10 year projection"));
        canvi[1].parentNode.append(tabler(["year","number"], e["employment"], true, "Accessible - Employment 10 year projection"));

        canvi[2].id = "education-" + i;
        canvi[2].appendChild(tabler(["level","percent"], e["education-attainment-levels"], false, "Accessible - Educational Attainment percentage breakdown"));
        canvi[2].parentNode.append(tabler(["level","percent"], e["education-attainment-levels"], true, "Accessible - Educational Attainment percentage breakdown"));

        let legend = item.querySelector(".chart-legend");
        legend.id = "legend-" + i;

        canvi = Array.prototype.slice.call(canvi);

        //set CTA button
        const cta = item.querySelector(".cta__button");

        cta.href = "https://grayson.emsicc.com/careers/" + e["title-slug"];
        cta.innerText = e["humanized-title"];
        //sort arrays in case misordered
        e["annual-earnings"] = e["annual-earnings"].sort(sortEarnings);
        e["employment"] = e["employment"].sort(sortEmployment);

        //store formatted data for canvases
        chartData.rows[i] = {
          charts: [
            {
              chart: {},
              canvas: canvi[0],
              data: {
                x: arrayColumns(e["annual-earnings"], "percentile"),
                y: arrayColumns(e["annual-earnings"], "earnings"),
              },
            },
            {
              chart: {},
              canvas: canvi[1],
              data: {
                x: arrayColumns(e["employment"], "year"),
                y: arrayColumns(e["employment"], "number"),
              },
            },
            {
              chart: {},
              canvas: canvi[2],
              data: {
                x: arrayColumns(e["education-attainment-levels"], "level"),
                y: arrayColumns(e["education-attainment-levels"], "percent"),
              },
            },
          ],
        };

        //append to DOM
        el.appendChild(item);
      });
    }

    function init() {
      controls.addEventListener("change", function () {
        let geoid = controls.querySelector("#geoid");
        let programs = controls.querySelector("#programs");
        mask.classList.remove("loaded");
        mask.classList.add("loading");
        spinner.spin(wrapper);
        //remove existing results from DOM
        //console.log("Children to be removed:");
        //console.log(el.childNodes);

        while (el.firstChild) {
          el.removeChild(el.firstChild);
        }
        while (mask.firstChild) {
          mask.removeChild(mask.firstChild)
        }
        //clear chart data object
        chartData.rows = [];
        //remove pager
        document.getElementById("pager").remove();
        //make new http request
        makeRequest(programs.value, geoid.value);
        //console.log("THIS IS CHARTDATAAAAA");
        //console.log(chartData);
      });
      el.addEventListener("click", handleCharts, false);
    }

    function makeRequest(slug, radiusId) {
      //Make HTTP Request to local API
      fetch("/api/get-career.php", {
        method: "POST",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "slug=" + slug + "&" + "geoid=" + radiusId,
      })
        .then((response) => {
          if (response.ok) {
            //return if request successfull
            return response.json();
          } else { 
            throw new Error(
              'Failed to load career information, please contact site administrator at <a href="webmaster@grayson.edu">webmaster@grayson.edu</a>'
            );
          }
        })
        .then((json) => fillTemplate(json))
        .then(() => mask.prepend(el))
        .then(() => new Pager(el, 5))
        .then(() => {
          mask.classList.remove("loading");
          mask.classList.add("loaded");
          spinner.stop();
        })
        .catch((e) => {
          let message = document.createTextNode(e.message);
          let paragraph = document.createElement("p");
          paragraph.appendChild(message)
          mask.appendChild(paragraph);
          paragraph.style = "text-align:center;";
          mask.classList.remove("loading");
          mask.classList.add("loaded");
          spinner.stop();
        });
    }
    init();
    //console.log('testing');
    makeRequest(wrapper.getAttribute("data-slug"), controls.querySelector("#geoid").value);
  }
})();
